import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import __ from 'utils/i18n';
import StateBadge from 'components/StateBadge';
import { getConfig } from 'config';
import { apiRequestPromise } from 'api-provider';
import { downloadBase64Pdf } from 'utils/downloadBase64Pdf';
import { downloadQR } from './resources';

const UserName = (userId) => ({ original }) => {
  const name = original.firstName;
  const surname = original.lastName;
  const fullname = surname ? `${name} ${surname}` : name;
  const iconClass = (userId === original.id) ? "account-circle" : "account";

  return (
    <span>
      <i className={`ft-icon mdi mdi-${iconClass}`} />
      <span className="user--name">{fullname || "-"}</span>
    </span>
  );
};

const UserStatus = ({ original }) => {
  const status = original.status || original.enableName;
  return status ? <StateBadge state={status} /> : "";
};

const UserSubsidiaries = ({ original }) => {
  if (original.subsidiaryName) {
    return original.subsidiaryName;
  } else {
    const subsidiaries =
      original.subsidiary.length === 1
        ? original.subsidiary[0].subsidiaryName
        : `${original.subsidiary.length} sucursales`;
    return <span className="user--subsidiaries">{subsidiaries}</span>;
  }
};

// Componente con hooks para el botón
const QRDownloadButtonComponent = ({ pointOfSaleUUID, token }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadQR = async (e) => {
    e.stopPropagation();
    setIsDownloading(true);
    
    try {
      // Llamada al backend para obtener el QR
      const resourceConfig = downloadQR(pointOfSaleUUID, token);
      const response = await apiRequestPromise({
        url: resourceConfig.endpoint,
        method: resourceConfig.method,
        headers: resourceConfig.headers,
      });

      // Extraer pdf_base64 de la respuesta
      const pdfBase64 = response?.data?.pdf_base64 || response?.data?.data?.pdf_base64;
      
      if (!pdfBase64) {
        throw new Error('No se recibió el PDF del servidor');
      }

      downloadBase64Pdf(pdfBase64, `QR-${pointOfSaleUUID}.pdf`);
    } catch (error) {
      console.error('Error al descargar QR:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Button
      color="primary"
      size="sm"
      onClick={handleDownloadQR}
      disabled={isDownloading}
      title={__('dashboard.sections.merchantUsers.downloadQR')}
    >
      {isDownloading ? (
        <>
          <i className="mdi mdi-loading mdi-spin" />
          {__('dashboard.sections.merchantUsers.downloading')}
        </>
      ) : (
        <>
          <i className="mdi mdi-qrcode-scan" />
          {__('dashboard.sections.merchantUsers.downloadQR')}
        </>
      )}
    </Button>
  );
};

// Conectar componente con Redux para obtener token
const ConnectedQRDownloadButtonComponent = connect(
  ({ api }) => ({ token: api.token })
)(QRDownloadButtonComponent);

// Función Cell sin hooks que retorna el componente conectado
const QRDownloadButton = ({ original }) => {
  const pointOfSaleUUID = original?.point_of_sale_uuid || original?.pointOfSaleUUID;

  if (!pointOfSaleUUID || pointOfSaleUUID.trim() === '') {
    return null;
  }

  return <ConnectedQRDownloadButtonComponent pointOfSaleUUID={pointOfSaleUUID} />;
};

export const getUsersColumns = (userId, getNameColumns) => {
  const usersColumns = [];
  const configColumns = getConfig("tableColumns.usersColumns");
  
  const defaultColumns = {
    name: {
      Header: __('dashboard.sections.merchantUsers.name'),
      Cell: UserName(userId),
      showIcon: false,
      width: 350,
    },
    email: {
      Header: __('dashboard.sections.merchantUsers.email'),
      name: 'email',
      width: 300,
      maxWidth: 300,
    },
    role: {
      Header: __('dashboard.sections.merchantUsers.role'),
      name: getNameColumns(),
      width: 250,
      maxWidth: 250,
    },
    local: {
      Header: __('dashboard.sections.merchantUsers.local'),
      Cell: UserSubsidiaries,
      width: 300,
      maxWidth: 300,
    },
    qrDownload: {
      Header: __('dashboard.sections.merchantUsers.qrDownload'),
      Cell: QRDownloadButton,
      width: 180,
      maxWidth: 180,
      disableSortBy: true,
    },
    state: {
      Header: __('dashboard.sections.merchantUsers.state'),
      Cell: UserStatus,
      width: 150,
      maxWidth: 150,
    }
  };

  configColumns.forEach((item) => usersColumns.push(defaultColumns[item]));

  return usersColumns;
};
